<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div id="dialogBoxWare" class="dialogData">
      <div class="orderListBox">
        <div class="orderList orderListTop">
          <div class="checkbox">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
          </div>
          <div>{{$t('base.orderNumber')}}</div>
          <div>{{$t('base.tax')}}</div>
          <div>{{$t('base.orderTotal')}}</div>
          <div class="createTime">{{$t('base.createTime')}}</div>
          <div class="operate">{{$t('base.operate')}}</div>
        </div>

        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye"/>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" v-if="!resultTpye">
          <div class="" style="height:300px;" v-loading="loading">
            <el-scrollbar class="orderScrollbar">
              <ul class="infinite-list" v-infinite-scroll='getOrderBusinessType' infinite-scroll-distance="25" :infinite-scroll-disabled="disabled">
                <li class="orderList" v-for="(item,index) in orderList" :key="index">
                  <div class="checkbox">
                    <el-checkbox :label="item"></el-checkbox>
                  </div>
                  <div>{{item.Code}}</div>
                  <div>{{item.RealLowestPriceUnit}} {{item.TaxPriceUsd.toFixed(2)}}</div>
                  <div>{{item.RealLowestPriceUnit}} {{item.RealTotalPrice.toFixed(2)}}</div>
                  <div class="createTime">{{setTime(item.CreateDate)}}</div>
                  <div class="operate"><span class="view" @click="goto(item,'taxorderlist')">{{$t('base.viewDetails')}}</span></div>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </el-checkbox-group>
      </div>

      <div class="footer">
        <el-button class="base" @click="handleClose">{{$t('base.back')}}</el-button>
        <el-button class="base" type="primary" @click="confirmOrder">{{$t('base.confirm')}}</el-button>
      </div>
      <tax-order-list title="Order Details" dialogClass="taxBox" :list="taxOrderDetail" :domVisible='dislogType.taxorderlist' @closeDialog="closeDialog" v-if='dislogType.taxorderlist' />
    </div>
  </el-dialog>
</template>
<script>
import TaxOrderList from "@/components/dialog/taxorderlist"; // 
import NOTN from "@/components/notnull.vue";
import { getTime } from "@/api/public";
export default {
  name: 'taxDetails',
  data() {
    return {
      resultTpye:false,
      loading:false,
      title: '',
      orderList: [],
      taxOrderDetail: {},
      disabled: false,
      pi: 1,
      ps: 20,
      dislogType: this.$enumInfo.dislogType,
      checkAll: false,
      checkedCities: [],
      isIndeterminate: false,
    }
  },
  components: { TaxOrderList ,NOTN},
  props: {
    dialogClass: '',
    domVisible: Boolean,
    orderType: null,
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {
    this.getOrderBusinessType()
  },
  methods: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    handleClose() {
      this.$emit('closeDialog', 'taxorder', false)
    },
    confirmOrder() {
      let that = this
      let data=that.checkedCities.length>0?that.checkedCities:''
      that.$emit('getOrderList', data)
      that.handleClose()
    },
    goto(obj, val) {
      this.taxOrderDetail = obj
      this.closeDialog(val, true)
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    getOrderBusinessType() {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps, BusinessType: that.orderType }
      if (that.orderType) {
        that.title = that.orderType == 2 ? 'Cross-border' : 'Domestic'
      }
      if (!that.disabled) {
        that.disabled = true
        that.loading=true
        that.$get(this.$interface.GetRefundTaxOrderPage, data).then(res => {
          if (res.Result != 0) {
            if(res.Count<=0){
              that.resultTpye=true
              return 
            }
            var data = res.Data
            if (data.length > 0) {
              that.pi++
              that.disabled = false
              that.orderList = [...that.orderList, ...data]
            } else {
              that.disabled = true
            }
          } else {
            that.resultTpye=true
            that.disabled = true
          }
          that.loading=false
        }).catch(error => {
          that.resultTpye=true
          that.disabled = false
          that.loading=false
        })
      }
    },
    handleCheckAllChange(value) {
      console.log(value, 'handleCheckAllChange')
      let that = this
      let data = [];
      if (value) {
        data = that.orderList;
      }
      that.checkedCities = data;
      that.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      console.log(value, 'value')
      let checkedCount = value.length;
      //this.$store.commit('SET_HEADER_TITLE','Shopping cart ( <span class="text_blue">'+checkedCount+'</span> Items)');
      this.checkAll = checkedCount === this.orderList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.orderList.length;
    },
    // 下拉刷新
    upLoad() {
      console.log('show')
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

/deep/ .base {
  padding: 9px 12px;
}

#dialogBoxWare {
  min-height: 400px;
  max-height: 80vh;
}

.orderList {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.orderListTop {
  background-color: #f7f7f7;
}

.orderList>div {
  width: 20%;
  padding: 16px 12px;
  color: #333;
  box-sizing: border-box;
}

.orderList>div.createTime {
  width: 25%;
}

.orderList>div.operate {
  width: 15%;
}

.view {
  cursor: pointer;
}

.view:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.like_img {
  width: 104px;
  height: 104px;
  display: block;
  margin-top: 16px;
}

.orderStateDetail li {
  margin-bottom: 16px;
}

.orderStateDetail li>span {
  margin-right: 8px;
}

.orderScrollbar {
  height: 100%;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
  height: 100%;
}

/deep/ .el-checkbox__label {
  display: none;
}

.orderList>.checkbox {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0;
  padding-top: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/taxorder.vue